import isNil from "lodash/isNil";
import type { Currency } from "../../data/BaseEntity";
import { Price } from "../../misc/price";
import type { SelectedProductOption } from "./price/getOptionPrice";

export function getOptionHint(
  selectedOption: SelectedProductOption & { readonly priceListPrice: Price; readonly availableQuantity?: number },
  currency: Currency | undefined,
  exchangeRate: number | undefined,
) {
  if (isNil(selectedOption.id)) {
    return undefined;
  }
  const price = isNil(selectedOption.price) ? selectedOption.priceListPrice : new Price(selectedOption.price);
  if (price.isPresent() && !isNil(currency)) {
    const priceText = getPriceText(exchangeRate, currency, price, selectedOption);
    return selectedOption.availableQuantity !== undefined
      ? `${priceText} (${selectedOption.availableQuantity} szt.)`
      : priceText;
  }
  return price.toDisplayValue(currency);
}

function getPriceText(
  exchangeRate: number | undefined,
  currency: "EUR" | "PLN",
  price: Price,
  selectedOption: {
    readonly priceListPrice: Price;
  },
) {
  if (isNil(exchangeRate)) {
    return Price.invalid.toDisplayValue(currency);
  }
  const priceInOrderCurrency = price.multiply(exchangeRate).round().toDisplayValue(currency);
  if (price.equals(selectedOption.priceListPrice)) {
    return priceInOrderCurrency;
  }
  return `${priceInOrderCurrency} *`;
}
